import { render, staticRenderFns } from "./body-config.vue?vue&type=template&id=199b2176&scoped=true&"
import script from "./body-config.vue?vue&type=script&lang=ts&"
export * from "./body-config.vue?vue&type=script&lang=ts&"
import style0 from "./body-config.vue?vue&type=style&index=0&id=199b2176&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199b2176",
  null
  
)

export default component.exports